import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';

import { PATH } from '../../../constants';

const Error = props => {
    const { t } = useTranslation();

    const headingClasses = classNames('help-page__error-heading', {
        'help-page__error-heading--404': props.pageNotFound
    });

    return (
        <div className="help-page help-page--error-page">
            <div className="help-page__error-wrapper">
                <header>
                    <h1 className={headingClasses}>{props.pageNotFound ? `${t('layout.error.header.notFound')}` : `${t('layout.error.header.unavailable')}`}</h1>
                </header>
                <div className="help-page__error-content">
                    <p>{t('layout.error.line1')}</p>
                    <p>{t('layout.error.line2')} <Link
                        to={`${PATH.helpAndSupport}`}
                        title={t('layout.error.hsLink.title')}>{t('layout.error.hsLink.text')}
                    </Link> {t('layout.error.line2Separator')} <a href={t('layout.error.contactLink.href')} title={t('layout.error.contactLink.title')}>{t('layout.error.contactLink.text')}</a>.</p>
                </div>
            </div>
        </div>
    );
};

export default Error;
